import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <path
      d="M18.17 0H2.13C.96 0 0 .94 0 2.09v19.82C0 23.06.96 24 2.13 24h19.73c1.18 0 2.13-.94 2.13-2.09V5.33L18.17 0zM12 18c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm5-10H4V3h13v5z"
      fill={ fill }
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
